import type { Benutzer } from "./typen";

/* ══════════════════════════════════════════════════════════════════
   Was die Spalte „MFA" unter Benutzer und Rechte sagt.

   **Seit dem 03.10.2026 aus dem Konto, nicht aus dem Wunsch** (Playbook
   E-06/E-09). Bis dahin hieß `mfa_required` „TOTP aktiv" — sobald die
   Verwaltung den Faktor *verlangte*, stand die grüne Marke da, auch wenn
   nichts eingerichtet war (und der Zugang damit ausgesperrt). Und wer
   gar kein Konto hatte, trug „einzurichten".

   Vier Zustände:
     `aktiv`           ein Faktor ist am Konto eingerichtet (bestätigt)
     `einzurichten`    verlangt, aber noch keiner eingerichtet
     `nicht_verlangt`  Konto ohne Verlangen und ohne Faktor
     `kein_konto`      ohne Zugang gibt es nichts, wofür ein Faktor gälte
   ══════════════════════════════════════════════════════════════════ */

export function mfaStand(zeile: {
  user_id?: unknown;
  mfa_required?: unknown;
  konto?: { faktor_eingerichtet?: unknown } | null;
}): Benutzer["mfa"] {
  if (typeof zeile.user_id !== "string" || zeile.user_id === "") return "kein_konto";
  if (zeile.konto?.faktor_eingerichtet === true) return "aktiv";
  return zeile.mfa_required === true ? "einzurichten" : "nicht_verlangt";
}
